var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#262D30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 32.25H18.4957C15.7911 32.2229 13.2065 31.1354 11.3036 29.2239C9.40078 27.3124 8.33337 24.7314 8.33337 22.0417C8.33337 19.352 9.40078 16.771 11.3036 14.8595C13.2065 12.948 15.7911 11.8605 18.4957 11.8334H20V15.8647H18.4957C16.8622 15.8858 15.3029 16.5458 14.1553 17.702C13.0077 18.8581 12.3642 20.4172 12.3642 22.0417C12.3642 23.6662 13.0077 25.2253 14.1553 26.3814C15.3029 27.5376 16.8622 28.1976 18.4957 28.2187H20V32.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28.1661H21.4772C22.8104 28.1798 24.1331 27.9258 25.3687 27.4189C26.6044 26.912 27.7284 26.1623 28.676 25.2131C29.6235 24.2638 30.3757 23.1339 30.889 21.8887C31.4024 20.6434 31.6667 19.3076 31.6667 17.9583C31.6667 16.6091 31.4024 15.2732 30.889 14.028C30.3757 12.7827 29.6235 11.6528 28.676 10.7036C27.7284 9.75437 26.6044 9.00464 25.3687 8.49776C24.1331 7.99087 22.8104 7.7369 21.4772 7.75052H20V11.7775H21.4772C22.2854 11.7669 23.0877 11.9188 23.8374 12.2244C24.5871 12.5301 25.2694 12.9834 25.8446 13.558C26.4199 14.1326 26.8766 14.8171 27.1883 15.5717C27.5001 16.3264 27.6606 17.1362 27.6606 17.9542C27.6606 18.7721 27.5001 19.5819 27.1883 20.3366C26.8766 21.0913 26.4199 21.7758 25.8446 22.3504C25.2694 22.925 24.5871 23.3783 23.8374 23.6839C23.0877 23.9896 22.2854 24.1415 21.4772 24.1309H20V28.1661Z",
    fill: "#2445E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLogo);
export default __webpack_public_path__ + "static/media/darkLogo.cf92f78c.svg";
export { ForwardRef as ReactComponent };